import axios from "axios";

const _axios = axios.create();

_axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

export default _axios;
